/*
Copyright 2025 TekNix Corporation

This software is proprietary and confidential to TekNix Corporation.
All rights reserved. No part of this software may be reproduced, distributed,
or transmitted in any form or by any means, including photocopying, recording,
or other electronic or mechanical methods, without the prior written permission
of TekNix Corporation, except in the case of brief quotations embodied in
critical reviews and certain other noncommercial uses permitted by copyright law.

For permission requests, write to TekNix Corporation at the address below:
TekNix Corporation
Legal Department

UNAUTHORIZED REPRODUCTION OR DISTRIBUTION IS STRICTLY PROHIBITED.
*/

export enum ClientPrefix {
  /**
   * A constant representing the URI path for Client-Server API endpoints versioned at v1.
   */
  V1 = '/api/v1',
}

export enum MediaPrefix {
  /**
   * A constant representing the URI path for Client-Server API Media endpoints versioned at v1.
   */
  V1 = '/api/v1/media',
}
